import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QueryKey } from 'modules/Monitoring/consts/query/queryKey'
import { ChanneledRequestParams, Specialisation } from 'modules/Monitoring/types'

import { getSpecialisations } from './requests'

export const useSpecialisationQuery = (
  params: ChanneledRequestParams,
  options: Partial<UseQueryOptions<Specialisation[]>> = {},
) => {
  return useQuery({
    queryKey: [QueryKey.GetSpecialisations, params],
    queryFn: () => getSpecialisations(params),
    ...options,
  })
}
